export const libraryPath = Object.freeze({
  STORY: 'story',
  TOPIC: 'topic',
  PAGE: 'page',
  ASSET: 'asset',
});
